import { sortBy } from "lodash-es";
import { For, Show, createEffect, createMemo, createSignal } from "solid-js";
import toast from "solid-toast";
import type { EcoCode } from "~/types/EcoCode";
import { REPERTOIRE_STATE, USER_STATE } from "~/utils/app_state";
import { rspcClient } from "~/utils/rspc_client";
import { TextInput } from "./TextInput";

export const EcoCodesDashboard = () => {
	const ecoCodes = () => REPERTOIRE_STATE().ecoCodes;
	createEffect(() => {
		if (USER_STATE().user) {
			REPERTOIRE_STATE().fetchEcoCodes();
		}
	});
	return (
		<Show when={ecoCodes()}>
			<EcoCodesInner />
		</Show>
	);
};

const EcoCodesInner = () => {
	const ecoCodes = createMemo(() => {
		return sortBy(REPERTOIRE_STATE().ecoCodes!, (e) => e.fullName);
	});
	return (
		<div class="flex flex-col gap-4">
			<h1>Eco codes</h1>
			<For each={ecoCodes()}>{(ecoCode) => <EcoCodeRow ecoCode={ecoCode} />}</For>
		</div>
	);
};

const EcoCodeRow = (props: { ecoCode: EcoCode }) => {
	let [friendlyName, setFriendlyName] = createSignal(props.ecoCode.friendlyName ?? "");
	return (
		<div class="flex gap-4 items-start p-4 bg-gray-25">
			<p class="text-primary font-medium">{props.ecoCode.fullName}</p>
			<p class="text-secondary font-medium">{props.ecoCode.epd}</p>
			<TextInput
				name="friendlyName"
				placeholder={"Friendly name"}
				setFields={(_name, v) => {
					setFriendlyName(v);
				}}
				value={friendlyName()}
			/>
			<div
				class="cursor-pointer bg-blue-20 p-4 hover:bg-blue-30 rounded-sm"
				use:onClick={() => {
					rspcClient
						.query([
							"admin.updateFriendlyName",
							{ epd: props.ecoCode.epd, friendlyName: friendlyName() },
						])
						.then(() => {
							setFriendlyName(friendlyName());
							toast.success("Saved!");
						})
						.catch((e) => {
							toast.error(e.message);
						});
				}}
			>
				Save
			</div>
		</div>
	);
};
